<template>
  <span class="badge" :class="value == 1 ? 'score-1' : 'score-4'">
    {{ value == 1 ? 'High Value' : 'Not High Value' }}
  </span>
</template>

<script>
export default {
  name: 'HighValueBadge',
  props: { value: { type: [Number, String, Boolean], default: 0 } }
}
</script>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
  width: fit-content;
}
.badge.score-1 { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
.badge.score-4 { background: #fff7ed; color: #c2410c; border: 1px solid #ffedd5; }
</style>
